<template lang="html">
  <section class="download-contract">
    <vue-pdf-viewer class="download-contract" :url="src" v-loading="loading" :height="height"></vue-pdf-viewer>
  </section>
</template>

<script>
import api from '../../../api'
import VuePDFViewer from 'vue-instant-pdf-viewer'
export default {
  name: 'DownloadContract',
  components: {
    'vue-pdf-viewer': VuePDFViewer
  },
  data() {
    return {
      src: '',
      loading: false
    }
  },
  computed: {
    height() {
      return (document.documentElement.clientHeight - 100) + 'px'
    }
  },
  created() {
    const vm = this
    this.loading = true
    api.FetchContract({
      merchantId: this.$store.state.user.userinfo.merchantId,
      name: this.$store.state.theme.name
    }).then(res => {
      if (res.data.code === 200) {
        vm.src = res.data.data.contractUrl + '&type=agreement'
        // api.FetchContractFile({
        //   type: 'agreement',
        //   url: 'http://silot-admin-dev.s3-ap-northeast-2.amazonaws.com/10161973e68d590865c64b8b5da73637.pdf'
        // }).then(res => {
        //   if (res.status === 200) {
        //     const url = window.URL.createObjectURL(new Blob([res.data], {
        //       type: 'application/pdf'
        //     }))
        //     vm.src = url
        //   }
        // })
      }
      this.loading = false
      // if (res.data.code === 200) {
      //   const url = window.URL.createObjectURL(new Blob([res.data]))
      //   vm.src = 'https://silot-admin-dev.s3-ap-northeast-2.amazonaws.com/a4193dc363394c3fbc34026ae3606025.pdf'
      //   this.btnDisable = false
      // }
      // this.loading = false
    })
  }
}
</script>

<style scoped>
.download-contract {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// contract.vue?6b5a2d14